import { Navigate, Route, useParams, useNavigate, Outlet } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { useEffect } from 'react';
import { ProtectedRoute } from 'ProtectedRoute';
import { StudentDashboard } from './StudentDashboard';
import { isValidDashboardTab } from './typeGuards';

export const STUDENT_DASHBOARD_ROUTES = {
    DASHBOARD: { path: '/dashboard' },
    DASHBOARD_TAB: { path: '/dashboard/:studyTab' },
};

const DEFAULT_DASHBOARD_PATH = '/dashboard/currently-studying';

export function configureStudentDashboardRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: STUDENT_DASHBOARD_ROUTES,
            config: {},
        },
    ];
}

export function getStudentDashboardRoutes() {
    return (
        <Route id="student-dashboard-routes" element={<Outlet />}>
            <Route
                path={STUDENT_DASHBOARD_ROUTES.DASHBOARD.path}
                element={
                    <ProtectedRoute accessPolicy="hasLearnerAccess" allowedOffline>
                        <Navigate to={DEFAULT_DASHBOARD_PATH} replace />
                    </ProtectedRoute>
                }
            />
            <Route
                path={STUDENT_DASHBOARD_ROUTES.DASHBOARD_TAB.path}
                element={
                    <ProtectedRoute accessPolicy="hasLearnerAccess" allowedOffline>
                        <EnsureValidStudentDashboardTab />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}

function EnsureValidStudentDashboardTab() {
    const { studyTab } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isValidDashboardTab(studyTab)) {
            navigate(DEFAULT_DASHBOARD_PATH, { replace: true });
        }
    }, [studyTab, navigate]);

    return <StudentDashboard />;
}
